import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const CTA_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/4b2b566e-774f-4d56-9f2d-b224d6a937be.jpg';
export function CTA() {
  return <section id="contact" className="w-full bg-ink-950 px-6 py-24 lg:px-8 lg:py-32" data-id="element-38" data-mp="1zg15z15e67dq">
      <Reveal className="mx-auto max-w-container" data-id="element-39" data-mp="1ui94pgiux8wv">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-ink-900 px-8 py-16 text-center lg:px-16 lg:py-24" data-id="element-40" data-mp="16rvkgc6ikecu">
          <img src={CTA_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-41" data-mp="11ud8se143l15" />
          <div className="absolute inset-0 bg-ink-950/60" data-id="element-42" data-mp="1bqydszd4sw4z" />
          <div className="relative mx-auto max-w-2xl" data-id="element-43" data-mp="1bpexx9ve0n3q">
            <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-white lg:text-5xl" data-id="element-44" data-mp="o0cim8o876ce">
              Ready to add $500K–$1M in the next 12 months?
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-white/70" data-id="element-45" data-mp="33dbrrkiud0tv">
              Book a strategy call. We&apos;ll map your fastest path to growth and
              show you exactly how the system would work for your business.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-46" data-mp="3d6kcz8tw1ws5">
              <a href="https://calendly.com/jmctagency/disco" target="_blank" rel="noreferrer" className="group inline-flex items-center justify-center gap-2 rounded-full bg-gold-500 px-8 py-4 text-sm font-semibold text-ink-950 transition-colors hover:bg-gold-400" data-id="element-47" data-mp="3h7manl85q0s0">
                Book a strategy call
                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-48" data-mp="2yglcgzev299i" />
              </a>
              <a href="mailto:hello@maedso.com" className="text-sm font-semibold text-white/80 transition-colors hover:text-white" data-id="element-49" data-mp="8sch51ic23vu">
                hello@maedso.com
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}